import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as contentblockActions from '../actions/content-blocks.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { ContentBlocksService } from '../../services';

@Injectable()
export class ContentBlocksEffects {
  constructor(private actions$: Actions, private PageService: ContentBlocksService) {}

  LoadBugs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadContentBlocks),
      switchMap(({ pageId }) =>
        this.PageService.getBlocksByPage(pageId).pipe(
          map(contentBlocks => contentblockActions.LoadContentBlocksSuccess({ pageId, contentBlocks })),
          catchError(error => of(contentblockActions.LoadContentBlocksFail({ pageId, error })))
        )
      )
    );
  });
}
